import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { Button, FormControl, TextField } from '@mui/material';
import * as yup from 'yup';
import { LoadingButton } from '@mui/lab';
import { nanoid } from 'nanoid';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import SaveIcon from '@mui/icons-material/Save';
import ModalWindow from '../ModalWindow/ModalWindow';
import { DashboardContext } from '../DashboardContext';
import { localizeErrors } from '../../../utils/helpers';

const AddCities = ({ open, handleClose, selectedCity, editMode }) => {
  const { fetchAddCities, isFetchingCities, fetchEditCities, citiesErrors } = useContext(DashboardContext);

  const submitForm = useCallback((value, resetForm) => {
    const { title } = value;
    if (editMode) {
      fetchEditCities({ id: selectedCity.id, title }).then((resp) => {
        if (resp === 'success') {
          handleClose();
          resetForm();
        }
      });
    } else {
      fetchAddCities({ title }).then((resp) => {
        if (resp === 'success') {
          handleClose();
          resetForm();
        }
      });
    }
  }, [selectedCity, fetchAddCities, handleClose, fetchEditCities, editMode]);

  const formik = useFormik({
    initialValues: {
      title: editMode ? selectedCity.title : ''
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      title: yup
        .string()
        .max(48, 'Максимально 48 символів')
        .required('Обов\'язково до заповнення')
    }),
    onSubmit: (values, { resetForm }) => {
      submitForm(values, resetForm);
    }
  });

  const onClickReset = () => {
    formik.resetForm();
    handleClose();
  };

  const renderErrors = useMemo(() => citiesErrors?.map((item) => <p key={nanoid()} className="errorText">{localizeErrors[item] || item}</p>), [citiesErrors]);

  return (
    <ModalWindow
      open={open}
      maxWidth="700px"
      onClose={handleClose}
      onBackdropClick={onClickReset}
    >
      <div className="addUsers addPopup">
        <form onSubmit={formik.handleSubmit}>
          <FormControl size="small" fullWidth>
            <TextField
              id="title"
              name="title"
              size="small"
              label="Назва міста *"
              value={formik.values.title}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Введіть назву міста"
              error={formik.touched.title && Boolean(formik.errors.title)}
              helperText={formik.touched.title && formik.errors.title}
            />
            {renderErrors}
          </FormControl>
          <div className="addUsers-actions">
            <LoadingButton
              variant="contained"
              type="submit"
              loading={isFetchingCities}
              disabled={!formik.isValid}
            >
              <SaveIcon sx={{ marginRight: '5px' }} />
              Зберегти
            </LoadingButton>
            <Button type="reset" variant="contained" color="error" onClick={() => onClickReset()}>
              <DisabledByDefaultIcon sx={{ marginRight: '5px' }} />
              Скасувати
            </Button>
          </div>
        </form>
      </div>
    </ModalWindow>
  );
};

AddCities.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  selectedCity: PropTypes.object,
  editMode: PropTypes.bool
};

export default AddCities;
